// extracted by mini-css-extract-plugin
module.exports = {"root":"StatsIndicator_root__jm9ZS","active":"StatsIndicator_active__ycvBf"};